export default __webpack_public_path__ + "static/media/download-doc.4f63c06e.svg";